import { send } from '../../../../../../src/network';

export async function postApiV2CustomersCustomerIdUnhold() {
  return send({
    path: '/api/v2/customers/self/unhold',
    method: 'POST',
  });
}
